$(document).ready(function() {



    var $sliders = $(".testimonial_slider");

    $sliders.slick({
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1,
        // dots: true,
        infinite: true,
        speed: 500,

    });
    updateCounters();
    var $prevButtons = $('#banner_prevs');
    var $nextButtons = $('#banner_nexts');


    var totalSlidess = $('.testimonial_slider').slick('getSlick').slideCount;
    var perSlidelines = 100 / totalSlidess
    var totalSlidess = $('.testimonial_slider').slick('getSlick').slideCount;
       
    var countallWidths = `calc(100% / ${totalSlidess.toString().padStart(2, '0')})`;
    $('span.countalls').css('width', countallWidths);

    $nextButtons.click(function() {
        $sliders.slick('slickNext');
        var currentSlides = $('.testimonial_slider').slick('slickCurrentSlide') + 1;
        var full_widths = perSlidelines * currentSlides;
        $('span.countalls').css('width', full_widths+'%');
    });

    $prevButtons.click(function() {
        $sliders.slick('slickPrev');
        var currentSlides = $('.testimonial_slider').slick('slickCurrentSlide') + 1;
        var full_widths = perSlidelines * currentSlides;
        $('span.countalls').css('width', full_widths+'%');
    });

    $('.testimonial_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        updateCounters();
      });
  
      function updateCounters() {
 
      
        var currentSlides = $('.testimonial_slider').slick('slickCurrentSlide') + 1;

      
        var totalSlidess = $('.testimonial_slider').slick('getSlick').slideCount;
    
        $('.slider_counts .active_counts').text( currentSlides.toString().padStart(2, '0'));
  
        $('.slider_counts .not_actives').text('/'+totalSlidess.toString().padStart(2, '0'));
      }

    
});